export const BRAND = {
  NAME: "DUMITRESCU PHOTOGRAPHY",
  TAGLINE: "Precision in Every Frame.",
  DESCRIPTION: "Professional photographer specializing in editorial, architectural, and portrait work with meticulous attention to detail.",
};

export const COLORS = {
  CHARCOAL_BLACK: "#1A1A1A",
  CLOUD_WHITE: "#F8F9FA",
  ELECTRIC_AMBER: "#FFB400",
} as const;

export const BREAKPOINTS = {
  MOBILE: 640,
  TABLET: 768,
  DESKTOP: 1024,
  WIDE: 1280,
} as const;

export const ANIMATION_DURATIONS = {
  FAST: 150,
  BASE: 300,
  SLOW: 500,
} as const;

export const NAVIGATION_IDS = {
  GALLERY: 'commercial-gallery',
  PROCESS: 'process',
  ABOUT: 'about',
  CONTACT: 'contact',
} as const;
